export const DEFAULT_PRESENTATION_SETTINGS = {
  layout: {
    productsPerRow: 4,
    showCategories: true,
    categoriesPosition: 'sidebar',
    showFilters: true,
    showSearch: true,
  },
  theme: {
    primaryColor: '#336b52',
    secondaryColor: '#10b981',
    backgroundColor: '#fafbfa',
    textColor: '#2f3431',
    accentColor: '#f59e0b',
  },
  typography: {
    fontFamily: 'Inter',
    headingSize: 'medium',
    bodySize: 'normal',
  },
  productDisplay: {
    showPrice: true,
    showDescription: true,
    showStock: false,
    imageAspectRatio: '1:1',
    hoverEffect: 'zoom',
  },
};

export const mergePresentationSettings = (presentation) => {
  if (!presentation) {
    return DEFAULT_PRESENTATION_SETTINGS;
  }

  return {
    layout: { ...DEFAULT_PRESENTATION_SETTINGS.layout, ...presentation.layout },
    theme: { ...DEFAULT_PRESENTATION_SETTINGS.theme, ...presentation.theme },
    typography: { ...DEFAULT_PRESENTATION_SETTINGS.typography, ...presentation.typography },
    productDisplay: {
      ...DEFAULT_PRESENTATION_SETTINGS.productDisplay,
      ...presentation.productDisplay,
    },
  };
};
